module.exports = __webpack_public_path__ + "media/images/teacher/courses-bought-f81d83dbda9e1ada4bcbf993194b3a3c.png";